import { render, staticRenderFns } from "./AssetsVehiclesShow.vue?vue&type=template&id=6ce59592&"
import script from "./AssetsVehiclesShow.vue?vue&type=script&lang=js&"
export * from "./AssetsVehiclesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports